import { combineReducers } from 'redux';
import types from './types';
import appTypes from '../app/types';
import viewTypes from '../view/types';
import omit from 'lodash/omit';

function instance(state = '', action = {}) {
  switch (action.type) {
    case types.REQUEST_INSTANCE_SUCCESS:
    case types.SAVE_INSTANCE_SUCCESS:
    case types.GENERIC_SUCCESS:
      if (!action.MetaData || action.MetaData.dataStoreId == null) {
        return state;
      }

      let instanceState = Object.assign({}, state, {
        [action.MetaData.dataStoreId]: action.response.response,
      });
      instanceState[action.MetaData.dataStoreId].validation = action.response.entityDescribe;
      return instanceState;
    case types.DELETE_INSTANCE_SUCCESS:
      if (action.MetaData.dataStoreId !== null && action.MetaData.dataStoreId !== undefined) {
        return Object.assign({}, state, { [action.MetaData.dataStoreId]: {} });
      }
      return state;
    default:
      return state;
  }
}

function list(state = '', action = {}) {
  switch (action.type) {
    case types.REQUEST_LIST_SUCCESS:
      if (action.MetaData.code !== state[action.MetaData.dataStoreId].code) {
        return state;
      }
      var data = [];
      var dataStore = state[action.MetaData.dataStoreId];
      if (!action.MetaData.replaceData && dataStore.data) {
        data = dataStore.data;
      }
      var rowno = 0;
      var numRows = action.MetaData.dataIndex + Object.keys(action.response.response).length - 1;
      for (var i = action.MetaData.dataIndex; i <= numRows; i++) {
        data[i] = action.response.response[rowno];
        rowno++;
      }
      var loadSequence = dataStore.loadSequence ? dataStore.loadSequence + 1 : 1;
      return Object.assign({}, state, {
        [action.MetaData.dataStoreId]: {
          isLoading: false,
          data: data,
          totalRecords: action.response.totalRecords,
          loadSequence: loadSequence,
          code: state[action.MetaData.dataStoreId].code,
        },
      });
    case types.RESET_LIST:
      var data = [];
      var dataStore = state[action.dataStoreId];
      var loadSequence = dataStore && dataStore.loadSequence ? dataStore.loadSequence + 1 : 1;
      return Object.assign({}, state, {
        [action.dataStoreId]: {
          isLoading: false,
          data: data,
          totalRecords: 0,
          loadSequence: loadSequence,
        },
      });
    case types.REQUEST_LIST_REQUEST:
      return Object.assign({}, state, {
        [action.MetaData.dataStoreId]: {
          ...state[action.MetaData.dataStoreId],
          isLoading: true,
        },
      });

    case types.SAVE_MENU_SUCCESS:
      var data = [];
      var fData = [];
      var dataStore = state.menu;
      var numRows = action.response.response.list.length;
      var fNumRows = action.response.response.fList.length;
      for (var i = 0; i < numRows; i++) {
        data[i] = action.response.response.list[i];
      }
      for (var j = 0; j < fNumRows; j++) {
        fData[j] = action.response.response.fList[j];
      }
      var loadSequence = dataStore.loadSequence ? dataStore.loadSequence + 1 : 1;
      return Object.assign({}, state, {
        menu: {
          isLoading: false,
          data: data,
          totalRecords: action.response.response.list.length,
          loadSequence: loadSequence,
        },
        folders: {
          isLoading: false,
          data: fData,
          totalRecords: action.response.response.fList.length,
          loadSequence: loadSequence,
        },
      });
    case types.SET_API_CODE:
      let apiCodeState = Object.assign({}, state, {
        [action.dataStoreId]: {
          ...state[action.dataStoreId],
          code: action.code,
        },
      });
      return apiCodeState;

    default:
      return state;
  }
}

function describe(state = '', action = {}) {
  switch (action.type) {
    case types.SCREEN_DETAILS_SUCCESS:
      // No update required if data entity already loaded (multiple screens may use the same data entity)
      if (state[action.MetaData.entity]) {
        return state;
      }
      return Object.assign({}, state, {
        [action.MetaData.entity]: {
          fields: action.response.response.fields,
          defaultRecord: action.response.response.defaultRecord,
        },
      });
    default:
      return state;
  }
}

//⏰
function alert(state = { validation: [], general: '', type: '' }, action = {}) {
  const CONFIRMATION_REQUIRED = 'CONFIRMATION_REQUIRED';

  const {
    alertId,
    alertText,
    alertType,
    alertForm,
    status,
    uuid,
    alertTitle,
    notificationActionId,
    notificationActionType,
    alertComponent,
    confirmationReference,
    responses,
    mutationProps,
    alert, //Alert in services representation (Alert.java)
    errorId,
  } = action?.MetaData || {};

  let duplicateId;
  switch (action.type) {
    case types.GENERIC_ALERT:
      if (status !== CONFIRMATION_REQUIRED) {
        if (state.notifications) {
          Object.keys(state.notifications).forEach((id) => {
            const notification = state.notifications[id];
            if (notification.form === alertForm && notification.general === alertText) {
              duplicateId = id;
            }
          });
        }
        return Object.assign({}, state, {
          notifications: {
            ...omit(state.notifications, duplicateId),
            [`${alertId}`]: {
              general: alertText,
              type: alertType,
              form: alertForm,
              status: status,
              uuid: uuid,
              title: alertTitle,
              alertId: alertId,
              alert: alert,
              errorId: errorId,
            },
          },
        });
      }
      return Object.assign({}, state, {
        confirmationPrompt: {
          general: alertText,
          type: alertType,
          form: alertForm,
          status: status,
          confirmationReference: confirmationReference,
          uuid: uuid,
          title: alertTitle,
          alertId: alertId,
          responses: responses,
          mutationProps,
        },
      });
    case types.DELETE_INSTANCE_SUCCESS:
      if (action && action.response && action.response.errorMessage) {
        return Object.assign({}, state, {
          validation: [],
          general: action.response.errorMessage,
          type: action.MetaData.alertType || 'info',
          status: '',
        });
      }
      break;
    case types.SAVE_INSTANCE_SUCCESS:
    case types.GENERIC_SUCCESS:
    case viewTypes.SET_DEFAULT_VIEW_SUCCESS:
      if (!action.MetaData) {
        return state;
      }

      return Object.assign({}, state, {
        validation: [],
        general: action.MetaData.alertText ? [action.MetaData.alertText] : null,
        type: action.MetaData.alertType || 'success',
        status: '',
      });
    case types.REQUEST_INSTANCE_FAILURE:
    case types.REQUEST_LIST_FAILURE:
    case types.SAVE_INSTANCE_FAILURE:
    case types.DELETE_INSTANCE_FAILURE:
    case types.GENERIC_FAILURE:
      return Object.assign({}, state, {
        validation: action.validationErrors,
        general: action.error,
        type: 'error',
        status: action.status,
        prompts: action.prompts,
      });
    case types.DISMISS_SYSTEM_ALERT:
      return Object.assign({}, state, {
        notifications: omit(state.notifications, action.MetaData.alertId),
      });
    case appTypes.USER_SUCCESS:
    case appTypes.LOGOUT_SUCCESS:
    case appTypes.SESSION_SUCCESS:
      return Object.assign({}, state, {
        validation: [],
        general: '',
        type: '',
        status: '',
      });
    case types.SWITCH_COMPANY_SUCCESS:
      return {};
    case types.DISMISS_CONFIRMATION_PROMPT:
      return Object.assign({}, state, {
        confirmationPrompt: null,
      });
    case types.FORM_CONFIRM_MESSAGE:
      let removePromptState = Object.assign({}, state);
      removePromptState.prompts.splice(0, 1);
      return removePromptState;
    case types.ACTION_ALERT:
      if (state.notifications) {
        Object.keys(state.notifications).forEach((id) => {
          const notification = state.notifications[id];
          if (notification.form === alertForm && notification.general === alertText) {
            duplicateId = id;
          }
        });
      }
      return Object.assign({}, state, {
        notifications: {
          ...omit(state.notifications, duplicateId),
          [`${alertId}`]: {
            title: alertTitle,
            general: alertText,
            type: alertType,
            form: alertForm,
            alertId: alertId,
            alert: alert,
            action: {
              id: notificationActionId,
              type: notificationActionType,
            },
          },
        },
      });
    case types.CUSTOM_ALERT:
      if (!alertComponent) {
        console.warn('Attempted to use a custom alert without providing any react component.');
        return;
      }
      return Object.assign({}, state, {
        notifications: {
          ...state.notifications,
          [`${alertId}`]: {
            title: alertTitle,
            type: alertType,
            alertId: alertId,
            component: alertComponent,
          },
        },
      });
    default:
      return state;
  }
}

const reducer = combineReducers({
  instance,
  list,
  alert,
  describe,
});

export default reducer;
